/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, select } from 'redux-saga/effects';
import { api, showSuccessNotification } from '@med-fe/util';
import {
  searchTemplateFailed,
  searchTemplateSuccess,
  searchTemplate,
  fetchOfficesSuccess,
  fetchEmployeesSuccess,
  SaveTemplateSuccess,
  SaveTemplateFailed,
  fetchTemplatePatternsSuccess,
  fetchCurrentPatternSuccess,
  fetchRCDByLocationNumberSuccess,
} from './actions';
import { showErrorNotification } from '@med-fe/util';

export function* searchTemplateStartWorker({ payload }): Generator {
  try {
    const url = `/templateAccomodation/get/all/${payload}`;
    const data = yield call(api.get, url, true, false);
    yield put(searchTemplateSuccess(data));
  } catch (e) {
    yield put(searchTemplateFailed(e));
    showErrorNotification();
  }
}

export function* fetchLocations(): Generator {
  try {
    const data = yield call(api.get, `/offices`, true, false);
    yield put(fetchOfficesSuccess(data));
  } catch (e) {
    showErrorNotification(null, e);
  }
}

export function* fetchODs(): Generator {
  try {
    const data = yield call(api.get, `/od/list`, true, false);
    yield put(fetchEmployeesSuccess(data));
  } catch (e) {
    showErrorNotification(null, e);
  }
}

export function* fetchTemplatePatterns(): Generator {
  try {
    const data = yield call(api.get, `/template/patterns`, true, false);
    yield put(fetchTemplatePatternsSuccess(data));
  } catch (e) {
    showErrorNotification(null, e);
  }
}

export function* fetchCurrentTemplatePatterns({ payload }): Generator {
  try {
    const { employeeNumber, locationNumber } = payload;

    const query = `?employeeNumber=${encodeURIComponent(employeeNumber)}&officeNumber=${encodeURIComponent(
      locationNumber
    )}`;

    const url = `/currentTemplate/pattern${query}`;
    const data = yield call(api.get, url, true, false);
    yield put(fetchCurrentPatternSuccess(data));
  } catch (e) {
    showErrorNotification(null, e);
  }
}

export function fetchChangeResults({ currentPattern, newPattern }) {
  try {
    const query = `?currentPattern=${encodeURIComponent(currentPattern)}&newPattern=${encodeURIComponent(newPattern)}`;
    const url = `/calculate/changeResults${query}`;
    return api.get(url, true, false);
  } catch (e) {
    showErrorNotification(null, e);
  }
}

export function* fetchRCDByLocationNumber({ payload }): Generator {
  try {
    const { locationNumber } = payload;

    const query = `?locationNumber=${encodeURIComponent(locationNumber)}`;

    const url = `/employee/rcd${query}`;
    const data = yield call(api.get, url, true, true);

    yield put(fetchRCDByLocationNumberSuccess(data));
  } catch (e) {
    showErrorNotification(null, e);
  }
}

export function* saveTemplateAccomodation({ payload }): Generator {
  try {
    const url = `/templateAccomodation/save`;
    const data = yield call(api.post, url, payload, null, true, false);
    yield put(SaveTemplateSuccess(data));
    showSuccessNotification('Template accommodation saved successfully!');
  } catch (e: any) {
    yield put(SaveTemplateFailed(e));

    const showWarning = e.error.messages
      ? e.error.messages[0].includes(
          'Appointments are already booked for this location and provider within these dates.'
        )
      : false;

    if (!showWarning) {
      showErrorNotification(
        e.error.messages ? e.error.messages[0] : 'Failed to save template accommodation. Please try again.'
      );
    }
  }
}

export function* deleteTemplateAccomodation({ payload }): Generator {
  try {
    const url = `/templateAccomodation/delete`;
    const data = yield call(api.delete, url, payload, true, false);
    yield put(searchTemplate('Pending'));
    showSuccessNotification(data || 'Template accommodation deleted successfully!');
  } catch (e: any) {
    showErrorNotification(
      e.error.messages ? e.error.messages[0] : 'Error while deleting template accommodation. Please try again.'
    );
  }
}
